// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"6a5a68e5","977":"6c3b2829"}[chunkId] + ".chunk.js";
};